<template>
  <div>
    <v-autocomplete
      :value="state"
      :items="filterStates"
      :label="$i18n.t(label)"
      @change="changedTo"
      ref="select"
      :clearable="clearable"
      :loading="loading"
      :rules="rules"
      :dense="dense"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div ripple dense class="height32">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <div ripple dense style="width:100%">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";
import { commonMixin } from "@/mixins/common";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "StateSelect",

  mixins: [Themeable, commonMixin],
  props: {
    value: {
      default: false
    },
    country: {
      default: false
    },
    dense: {
      default: false
    },
    label: {
      default: "State"
    },
    clearable: {
      default: false
    }
  }
})
export default class StateSelect extends (Vue, Themeable) {
  state = null;
  states = [];
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.state = null;
    this.$emit("input", null);
  }

  get filterStates() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.states;
    const fs = this.states.filter(function(s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) this.state = newVal;
    if (newVal && newVal.name) this.$emit("input", newVal.name);
    if (!newVal) this.$emit("input", null);
  }

  selectValue() {
    if (this.value) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].name === this.value) {
          this.state = this.states[i];
          break;
        }
      }
    }
  }
  async mounted() {
    await common.populateStates(this.country);
    if (common.states[this.country] == undefined)
      this.states = common.states[this.country];
    this.selectValue();
    this.loading = false;
  }

  @Watch("country", { immediate: true })
  async handler(val) {
    this.filter = "";
    this.loading = true;
    this.states = [];
    if (common.states[val] == undefined) await common.populateStates(val);
    const states = common.states[this.country];
    this.states = states;
    this.loading = false;
    this.selectValue();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
</style>
